<template>
  <div class="rows-container">
    <div class="row">
      <div class="title">
        <p>{{ $t("dispatching.instantOrders.pending", { count: totalPendingOrders < 0 ? 0 : totalPendingOrders }) }}</p>
            <p style="margin: 1%;">MC({{ this.pendingOrdersCount.count_mc < 0 ? 0 : pendingOrdersCount.count_mc }})
                EXT({{ this.pendingOrdersCount.count_ext < 0 ? 0 : pendingOrdersCount.count_ext }}) PEXT({{
                  this.pendingOrdersCount.count_pext < 0 ? 0 : pendingOrdersCount.count_pext }}) </p>
      </div>
      <InfinityScroll status="PENDING" time="INSTANT" ref="PENDING" :besoin="this.besoin" @loaded="pushID($event);"
        @updateTotal="totalPendingOrders = $event" @decreaseCount="totalPendingOrders--" />
    </div>
    <div class="row">
      <div class="title">
        <p>{{ $t("dispatching.instantOrders.dispatched") }}</p>
      </div>
      <InfinityScroll multiStatus="ACCEPTED|APPROVED" time="INSTANT" ref="ACCEPTED" :besoin="this.besoin"
        @loaded="pushID($event)" />
    </div>
    <div class="row">
      <div class="title">
        <p>{{ $t("dispatching.instantOrders.driverOnTheWay") }}</p>
      </div>
      <InfinityScroll multiStatus="ARRIVED|STARTED" time="INSTANT" ref="ARRIVED" :besoin="this.besoin"
        @loaded="pushID($event)" />
    </div>
    <div class="row">
      <div class="title">
        <p>{{ $t("dispatching.instantOrders.tripStarted") }}</p>
      </div>
      <InfinityScroll status="PICKED_UP" time="INSTANT" ref="PICKED_UP" :besoin="this.besoin"
        @loaded="pushID($event)" />
    </div>
    <div class="row">
      <div class="title">
        <p>{{ $t("dispatching.instantOrders.completed") }}</p>
      </div>
      <InfinityScroll multiStatus="DONE|PAID" time="INSTANT" ref="DONE" :besoin="this.besoin"
        @loaded="pushID($event)" />
    </div>
  </div>
</template>

<script>
import InfinityScroll from "@/components/dispatching/InfinityScroll.vue";
import socketEventsMixin from "@/mixins/socketEventsMixin.js";
import api from "@/constants/api.js";
import axios from "axios";

export default {
  name: "instant-orders",
  mixins: [socketEventsMixin],
  data() {
    return {
      ordersIDs: {
        CANCELLED: [],
      },
      pendingOrdersCount: [],
      totalPendingOrders: 0,
      besoin: 0,
      lastUpdate: ''
    };
  },
  events() {
    return {
      [this.api.SOCKET.EVENTS.NEW_NOW_BOOKING]: this.newNowBooking,
      [this.api.SOCKET.EVENTS.UPDATE_BOOKING_STATUS]: this.updateStatus,
      [this.api.SOCKET.EVENTS.RENEW_BESOIN]: this.renewBesoin,
      [this.api.SOCKET.EVENTS.EXPIRED_BESOIN]: this.expiredBesoin,
      [this.api.SOCKET.EVENTS.NEW_PENDING_BOOKING]: this.increasePendingBookingsCount,
      [this.api.SOCKET.EVENTS.UPDATE_BOOKING]: this.decreasePendingBookingsCount
    };
  },
  components: {
    InfinityScroll,
  },
  methods: {
    getPendingOrdersCount() {
      axios.get('pending_bookings_count/INSTANT',)
        .then((res) => {
          this.pendingOrdersCount = res.data.data;

        })
        .catch((err) => {
          this.errorMessage = err.response.data.message;
          console.log("err");
          console.log(this.errorMessage);
        })
    },
    pushID(evt) {
      let status = "";
      if (evt.status === "ACCEPTED" || evt.status === "APPROVED")
        status = "ACCEPTED";
      else if (evt.status === "ARRIVED" || evt.status === "STARTED")
        status = "ARRIVED";
      else status = evt.status;

      let id = evt.id;
      if (this.ordersIDs[status]) {
        this.ordersIDs[status].push(id);
      } else {
        this.ordersIDs[status] = [];
        this.ordersIDs[status].push(id);
      }
    },
    expiredBesoin(besoin) {
      // this.$store.commit("DELETE_BESOIN", besoin.booking_id);
      // console.log(this.$store.state.besoins);
    },
    renewBesoin(besoin) {
      this.besoin = besoin.booking_id;
      // this.$store.commit("SET_BESOIN", this.besoin);
      // console.log(this.$store.state.besoins);
    },
    updateStatus(id, newStatus, oldStatus, driver, ride_id, cancellationReason = null, bySystem = null) {
      //console.log(id, newStatus, oldStatus)
      let cancelled = ['CANCELLED', 'CAPTAIN_CANCELLED', 'PAX_CANCELLED', 'SYSTEM_CANCELLED', 'REJECTED'].includes(newStatus);

      let refName = "";
      if (newStatus === "ACCEPTED" || newStatus === "APPROVED")
        refName = "ACCEPTED";
      else if (newStatus === "ARRIVED" || newStatus === "STARTED")
        refName = "ARRIVED";
      else if (cancelled || newStatus == 'PAID')
        refName = 'DONE';
      else refName = newStatus;
      if (this.lastUpdate != `${id}:${newStatus}:${oldStatus}` && (newStatus === "ACCEPTED" || newStatus === "APPROVED" || (cancelled && oldStatus === "PENDING")))
        this.totalPendingOrders--;
      this.lastUpdate = `${id}:${newStatus}:${oldStatus}`;

      if (newStatus !== "PENDING") {
        this.$store.dispatch('updateBookingData', {
          id, newStatus, oldStatus, driver
        });
      }

      Object.entries(this.ordersIDs).forEach(([key, value]) => {
        for (let i = 0; i < value.length; i++) {
          if (value[i] === id && oldStatus !== "DONE") {

            let refKey = "";
            if (key === "ACCEPTED" || key === "APPROVED") refKey = "ACCEPTED";
            else if (key === "ARRIVED" || key === "STARTED") refKey = "ARRIVED";
            else refKey = key;

            let order = this.$refs[refKey].removeOrder(id);

            order.status = refName == 'DONE' && !cancelled ? 'PAID' : newStatus;
            if (driver) {
              order['captain_first_name'] = driver.first_name;
              order['captain_last_name'] = driver.last_name;
              order['taxi_number'] = driver.username;
              order['car_brand_model'] = driver.car_brand_model;
              order['car_brand'] = driver.car_brand;
              order['car_color'] = driver.car_color;
              order['car_plate_number'] = driver.car_plate_number;
              order['captain_conversation_id'] = driver.conversation_id;
              order['method'] = driver.method;
            }
            if (cancellationReason) {
              if (newStatus == "CAPTAIN_CANCELLED")
                order['captain_cancellation_reason'] = cancellationReason;
              else if (newStatus == 'SYSTEM_CANCELLED' || newStatus == 'REJECTED') {
                if (bySystem)
                  order['system_cancellation_reason'] = cancellationReason;
                else
                  order['user_cancellation_reason'] = cancellationReason;
              }

            }

            this.$refs[refName].addOrder(order);

            this.ordersIDs[refKey].splice(
              this.ordersIDs[refKey].indexOf(id),
              1
            );

            this.pushID({ status: refName, id: id });

            break;
          }
        }
      });
      this.getPendingOrdersCount();
    },
    newNowBooking(bookingData) {
    console.log("bookingData",bookingData)
      this.$refs["PENDING"].addOrder(bookingData);
      this.totalPendingOrders++;
      this.pushID({ status: "PENDING", id: bookingData.id });
      this.getPendingOrdersCount();
    },
    increasePendingBookingsCount(data) {
      // this.totalPendingOrders++;
      console.log(data);
    },
  },
  created() {
    this.getPendingOrdersCount();
  }
};
</script>

<style lang="scss" scoped>
.rows-container {
  width: 100%;
  height: 100%;
  float: left;
  display: flex;
  flex-direction: row;
  background-color: white;
  box-shadow: 0px 2px 6px rgba(0, 11, 138, 0.08);
  border-radius: 10px;
  margin-top: 20px;

  .row {
    flex-shrink: 0;
    flex: 1;
    min-width: 200px;
    min-height: 600px;
    max-height: 600px;
    float: left;
    padding-top: 16px;
    height: 100%;
    opacity: 0.9;

    .title {
      height: 50px;
      width: 100%;
      padding-bottom: 16px;
      float: left;
      border-bottom: 1px solid #c1c5d8;

      p {
        width: 100%;
        font-size: 14px !important;
        text-align: center;
        font-weight: 500;
        color: #4d4f5c;
        font-family: Poppins !important;
        padding: 0px;
        margin: 1%;
      }
    }

    &:not(:last-child) {
      border-right: 1px solid #c1c5d8;
    }

    &:hover {
      opacity: 1;
    }
  }
}
</style>
